<template>
    <section class="results">
        <h2>Résultats</h2>

        <article id="table">
            <table>
                <thead>
                    <tr>
                        <th>Prestation</th>
                        <th>Éligibilité</th>
                        <th>Détails</th>
                    </tr>
                </thead>

                <tbody>
                    <tr
                        v-for="prestation in prestations"
                        :key="prestation.prestation"
                    >
                        <td>{{ getProgramTitle(prestation.prestation) }}</td>

                        <td>
                            <span
                                class="tag"
                                :class="prestation.eligible ? 'success' : 'danger'"
                            >
                                {{ prestation.eligible ? 'ÉLIGIBLE' : 'INÉLIGIBLE' }}
                            </span>
                        </td>

                        <td>
                            <i
                                class="material-icons icon"
                                @click="showDetails(prestation)"
                            >
                                info
                            </i>
                        </td>
                    </tr>
                </tbody>
            </table>
        </article>

        <Modal v-model="showModal">
            <section class="details">
                <div class="title">
                    <h2>{{ getProgramTitle(selectedPrestation?.prestation) }}</h2>

                    <span
                        class="tag"
                        :class="selectedPrestation?.eligible ? 'success' : 'danger'"
                    >
                        {{ selectedPrestation?.eligible ? 'ÉLIGIBLE' : 'INÉLIGIBLE' }}
                    </span>
                </div>

                <article class="display">
                    <div
                        class="bubble"
                        :class="selectedPrestation?.eligible ? 'success-bg' : 'danger-bg'"
                    >
                        <p>
                            {{ selectedPrestation?.reason || 'Aucun détail disponible.' }}
                        </p>
                    </div>
                </article>
            </section>
        </Modal>
    </section>
</template>

<script setup>
import { ref } from 'vue'
import Modal from '@/components/Modal.vue'

const showModal = ref(false)
const selectedPrestation = ref(null)

defineProps({
    prestations: {
        type: Array,
        required: true
    }
})

function showDetails(prestation) {
    selectedPrestation.value = prestation
    showModal.value = true
}

const programTitles = {
    emg: "Activ'Créa Emergence (EMG)",
    pass_el1: "PASS EL1 — Je crée mon entreprise",
    pass_el3: "PASS EL3 — Je développe mon entreprise",
    iti: "ITI — Créer sa réussite",
    accelerateur_emergence: "Accélérateur Émergence",
    accelerateur_crea_individuel: "Accélérateur Création Individuelle",
    accelerateur_crea_dev: "Accélérateur Création Développement",
    agefiph_creation: "AGEFIPH Création",
    incubatest: "IncubaTest",
    bilan_competence_transition: "Bilan de Compétence Transition",
    formation_certifiante_bge: "Formation Certifiante BGE",
    acco_r: "Acco R - Accompagnement Renforcé",
    atr: "ATR",
    ept_11: "EPT 11 - Grand Paris Sud Est Avenir",
    ept_12: "EPT 12 - Grand Orly Seine Bievre ou GOSB"
}

function getProgramTitle(key) {
    return programTitles[key] ?? key
}
</script>

<style lang="scss" scoped>
.results {
    width: 100%;
    display: flex;
    flex-direction: column;

    gap: 2rem;

    h2 {
        margin: 0;
        text-align: center;
    }

    #info {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }
}

.bubble {
    border-radius: 15px;
    padding: 1rem 2rem;

    h3 {
        margin: 0;
    }

    * {
        margin: .25rem;
    }
}

.tag {
    text-align: center;

    border-radius: 5px;
    padding: 6px 12px;

    display: flex;
    width: fit-content;
    align-self: center;
    justify-self: center;

    &.success {
        background-color: $green;
        color: #000;
    }

    &.warning {
        background-color: $orange;
        color: #000;
    }

    &.danger {
        background-color: $darkred;
        color: #fff;
    }
}

.icon {
    display: flex;
    justify-content: center;
    align-content: center;

    color: $dark-blue;

    cursor: pointer;

    &:hover {
        color: $orange;
    }

    -webkit-user-select: none; /* Chrome, Safari */
    -moz-user-select: none;    /* Firefox */
    -ms-user-select: none;     /* Old Edge */
    user-select: none;
}

.success {
    color: $green
}

.warning {
    color: $orange;
}

.danger {
    color: $darkred;
}

.primary-bg {
    background-color: rgba($dark-blue, .15);
}

.success-bg {
    background-color: rgba($green, .15);
}

.warning-bg {
    background-color: rgba($orange, .15);
}

.danger-bg {
    background-color: rgba($darkred, .15);
}

.details {
    .title {
        h3 {
            color: $dark-blue;

            margin: 0;
        }
        
        display: flex;
        align-items: center;

        gap: .5rem;

        .priority {
            background-color: $green;
        }
    }
}

.display {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-block: 1rem;
}

.text-align {
    display: flex;
    align-items: center;
}
</style>